/**
 * Converts a Firestore timestamp to a date string
 * 
 * @param {timestamp} date
 * 
 * ```
 * <td>
 *   {ConvertDate(object?.enddate)}
 * </td>
 * 
 * ```
 * 
 * Documentation
 * - https://firebase.google.com/docs/reference/js/v8/firebase.firestore.Timestamp
 * - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 */

export default function ConvertDate(date){

    try {

        return `${new Intl.DateTimeFormat(
            'en-GB', 
            {
                dateStyle: 'medium', 
                timeStyle: 'short', 
                timeZone: 'Australia/Sydney',
            }
        ).format(
            date?.toDate()
        )} AEST`;

    } catch (error) {
        
        return;
        
    }
     
}

//--------------------------------------------------------